import React, { Component} from 'react';

import Select from './../Select';

const data = [{
    value: 0,
    label: "聘用"
}, {
    value: 1,
    label: "职员"
}, {
    value: 2,
    label: "雇员"
}, {
    value: 3,
    label: "劳务派遣"
}, {
    value: 4,
    label: "聘用慧谷"
}, {
    value: 5,
    label: "外籍教师"
}, {
    value: 6,
    label: "试用"
}, {
    value: 7,
    label: "其他"
}];


const TeacherProperty = (props) => (
    <Select name="teacherProperty" label="教师性质" data={data} {...props} ></Select>
);

export default TeacherProperty;